import { nextStepsConstants } from 'features/catalog/constants'
import { useFilterHashLink } from 'features/catalog/features/detail/hooks/use-filter-hash-link'
import type { Step } from 'features/catalog/features/detail/hooks/use-filter-hash-link'
import { CHARTS_2_URL } from 'features/charts-v2/paths'
import { FEEDBACK_URL } from 'features/feedback/paths'
import { KEYWORDS_URL } from 'features/keywords/paths'
// bully ignore[no-cross-feature-private-imports: type-only import; ScreenLinkService is injected by the caller (CatalogDetail, features/detail/Container.tsx), never constructed here. follow-up: .agents/follow-ups/bully-typescript-cross-feature-hooks.md]
import type { ScreenLinkService } from 'features/project/url-params/service'
import { Filters } from 'types/project'

export type NextStepLens =
  | 'theme'
  | 'brand'
  | 'source_type'
  | 'product_hierarchy'

export type CatalogDetailHeaderLink = {
  step: Step
  link: string | undefined
}

function findStep(lens: NextStepLens, page: string): Step {
  const step = nextStepsConstants[lens].find((s) => s.page === page)
  if (!step) throw new Error(`No nextStepsConstants entry for ${lens}/${page}`)
  return step
}

/**
 * Feedback/Charts/Keywords filter-hash links for the detail page header's
 * "jump to this item's filtered view" buttons. `screenLinkService` is
 * injected by the caller — service hooks must be called from `Container.tsx`
 * (`no-service-hooks-outside-containers`), and this is a plain hook file, not
 * one.
 */
export function useCatalogDetailHeaderLinks(params: {
  screenLinkService: ScreenLinkService
  lens: string
  filters: Filters
  projectId: string
}): CatalogDetailHeaderLink[] {
  const { screenLinkService, lens, filters, projectId } = params
  const nextStepLens = lens as NextStepLens

  const feedbackStep = findStep(nextStepLens, FEEDBACK_URL)
  const chartsStep = findStep(nextStepLens, CHARTS_2_URL)
  const keywordsStep = findStep(nextStepLens, KEYWORDS_URL)

  const feedbackLink = useFilterHashLink(
    screenLinkService,
    projectId,
    feedbackStep,
    filters,
  )
  const chartsLink = useFilterHashLink(
    screenLinkService,
    projectId,
    chartsStep,
    filters,
  )
  const keywordsLink = useFilterHashLink(
    screenLinkService,
    projectId,
    keywordsStep,
    filters,
  )

  return [
    { step: feedbackStep, link: feedbackLink },
    { step: chartsStep, link: chartsLink },
    { step: keywordsStep, link: keywordsLink },
  ]
}
